<template>
    <div>
      <carousel :perPage="1" :paginationEnabled="false">
        <slide>
          <div class="padding">
            <p fade-auto="firstfade" speed="fast">No matter how often I stare out of that window, the view never gets any better. My feet rest against the oven and I wedge myself into the space offered by the wooden frame. The wind bites, and my skin crinkles and the sirens sound from the river. Don't mind the cold though. Even welcome it some days. Once he's at school I need something to keep me awake before I go to work. Something to remind me to get out of these three rooms and go downstairs into the rain. My cereal's turned to mush. I turn the spoon around a few times and then throw the bowl into the street. Nobody will notice. His homework is pinned to the door. I wish he wouldn't do that. I remove the paper and read it. They have him writing structards.</p>

            <p>Home.<br>
            Cold.<br> </p>
            <p fadeauto="secondfade">Every day</p>.<br>
            <p fade-auto="thirdfade" speed="normal">Mornings are best</p>.<br>
            <p>The milk is white, creamy.<br>
            My clothes are folded into piles by mummy.<br>
            Jumpers, shirts and trousers.<br>
            Hair brushed down.<br>
            School time.<br>
            Later.<br>
            Home.</p>

            <p>That one word - cold - goes through me. He never complains, never questions. Each morning he dresses himself and eats his breakfast. He's cold. I let his mistake go uncorrected and I put my coat on.</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </div>
        </slide>
      </carousel>
    </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'I Stare Out of that Window'
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="css" scoped>
</style>
